// Sections that open in place (#1623): a `<details data-remember="key">` reopens as this browser last left it.
// Per-browser only, and best effort: storage that is blocked or full just means it starts closed.

const PREFIX = "crm.open.";

function readOpen(storage, key) {
  try {
    return storage?.getItem(PREFIX + key) === "1";
  } catch (err) {
    return false;
  }
}

function writeOpen(storage, key, open) {
  try {
    if (open) storage?.setItem(PREFIX + key, "1");
    else storage?.removeItem(PREFIX + key);
  } catch (err) {}
}

/** Restores and then follows every `details[data-remember]` under `root`; calling it again skips those it has seen. */
export function rememberDisclosures(root = document, storage = globalThis.localStorage) {
  root.querySelectorAll("details[data-remember]").forEach((el) => {
    if (el.dataset.rememberBound) return;
    el.dataset.rememberBound = "1";
    const key = el.dataset.remember;
    if (readOpen(storage, key)) el.open = true;
    el.addEventListener("toggle", () => writeOpen(storage, key, el.open));
  });
}
